<script setup lang="ts">
import { ModalConfirmation } from '@shared/ui/modals'

import { useDeleteTeam } from '../../../model/teams/delete-team.hook'

defineOptions({
  name: 'ModalDeleteTeam',
})

const { isOpen, isDeleting, confirm, cancel } = useDeleteTeam()
</script>

<template>
  <ModalConfirmation
    :show="isOpen"
    mode="delete"
    title="Delete team?"
    detail="Are you sure you want to delete this team? All of data will be permanently removed. This action cannot be uncompleted."
    button-title="Delete team"
    :loading="isDeleting"
    @click:confirm="confirm"
    @click:cancel="cancel"
  />
</template>
